import { render, staticRenderFns } from "./TicketChat.vue?vue&type=template&id=703b016e&scoped=true&lang=html"
import script from "./TicketChat.vue?vue&type=script&lang=js"
export * from "./TicketChat.vue?vue&type=script&lang=js"
import style0 from "./TicketChat.vue?vue&type=style&index=0&id=703b016e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b016e",
  null
  
)

export default component.exports